import React from "react";
import { NavigateFunction, RouteObject, Navigate, createSearchParams } from "react-router-dom";
import { Users, Firmware, Log, TerminalDataTable, FeedDayDataTable, FeedTimeDataTable, DeviceDataTable, FeedCurveDataTable, SystemDataTable, LANControllerConfig, FirmwareIO, DeviceChangeQueueList, DataTableActions, Companies, CreateCompany, Company, StationDataTable, Connected1801List, DeviceChangeQueue } from "../../Containers";
import TabMenu from "../Menus/tabMenu";
import { ToolsMenu_Pages } from "../pages";
import GraphQL from "../../Containers/FullViewScreens/ToolsScreens/Legacy/graphQL";

export const Router = [{
  element: null,
  children: [
    { 
      path: `${ToolsMenu_Pages.tools_log}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.tools_log} key={ToolsMenu_Pages.tools_log} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[]} />,
      children:[
        { index: true, Component:Log },
      ]
    },
    { 
      path: `${ToolsMenu_Pages.tools_config}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.tools_config} key={ToolsMenu_Pages.tools_config} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[]} />,
      children:[
        { index:true, Component: LANControllerConfig},
      ]
    },
    { 
      path: `${ToolsMenu_Pages.tools_firmware}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.tools_firmware} key={ToolsMenu_Pages.tools_firmware} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[ToolsMenu_Pages.tools_firmwareIO]} />,
      children:[
        { index: true, Component: Firmware },
        { path: `${ToolsMenu_Pages.tools_firmwareIO}`, Component: FirmwareIO }
      ]
    },
    { 
      path: `${ToolsMenu_Pages.tools_deviceDataTables}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.tools_queue_list} key={ToolsMenu_Pages.tools_deviceDataTables} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[ToolsMenu_Pages.tools_queue, ToolsMenu_Pages.tools_terminal, ToolsMenu_Pages.tools_feedDays, ToolsMenu_Pages.tools_feedTimes, ToolsMenu_Pages.tools_devices, ToolsMenu_Pages.tools_feedCurves, ToolsMenu_Pages.tools_systems, ToolsMenu_Pages.tools_actions, ToolsMenu_Pages.tools_stations]} />,
      children: [
        { index: true, Component: DeviceChangeQueueList },
        { path: `${ToolsMenu_Pages.tools_queue}`, Component: DeviceChangeQueue },
        { path: `${ToolsMenu_Pages.tools_terminal}`, Component: TerminalDataTable },
        { path: `${ToolsMenu_Pages.tools_feedDays}`, Component: FeedDayDataTable },
        { path: `${ToolsMenu_Pages.tools_feedTimes}`, Component: FeedTimeDataTable },
        { path: `${ToolsMenu_Pages.tools_devices}`, Component: DeviceDataTable },
        { path: `${ToolsMenu_Pages.tools_feedCurves}`, Component: FeedCurveDataTable },
        { path: `${ToolsMenu_Pages.tools_systems}`, Component: SystemDataTable },
        { path: `${ToolsMenu_Pages.tools_actions}`, Component: DataTableActions },
        { path: `${ToolsMenu_Pages.tools_stations}`, Component: StationDataTable },
      ]
    },
    { path:`/${ToolsMenu_Pages.tools_companies}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.tools_companies} main={ToolsMenu_Pages.tools_companies} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[ ToolsMenu_Pages.tools_createCompany, ToolsMenu_Pages.tools_company]}/>, 
      children:[
        {index: true, Component: Companies},
        { path: `${ToolsMenu_Pages.tools_createCompany}`, Component: CreateCompany },
        { path: `${ToolsMenu_Pages.tools_company}`, Component: Company },
        {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.tools_companies}`} />}
      ]
    },
    { path:`/${ToolsMenu_Pages.tools_users}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.tools_users} main={ToolsMenu_Pages.tools_users} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, Component:Users},
        {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.tools_users}`} />}
      ]
    },
    { path:`/${ToolsMenu_Pages.tools_graphQL}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.tools_graphQL} main={ToolsMenu_Pages.tools_graphQL} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, Component:GraphQL},
        {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.tools_graphQL}`} />}
      ]
    },
    { 
      path: `${ToolsMenu_Pages.tools_server}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.tools_connected_1801} key={ToolsMenu_Pages.tools_connected_1801} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[]} />,
      children:[
        { index: true, Component: Connected1801List },
      ]
    },
  ]
}] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page: ToolsMenu_Pages, navigation_tab: ToolsMenu_Pages, currentDomain?: string) => { //TODO: populate nested navigations?
  const search = currentDomain ? createSearchParams({domain: currentDomain }).toString() : undefined;
  switch (navigation_page) {
    case ToolsMenu_Pages.home: {
      Navigator({pathname: ToolsMenu_Pages.home, search})
      break
    }

    case ToolsMenu_Pages.tools_log: {
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.tools_log}`, search}, {state:{global_index: 0, tab:0}})
          break
        }
      }
      break
    }

    case ToolsMenu_Pages.tools_config: {
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.tools_config}`, search}, { state: { global_index: 1, tab: 0 } })
          break
        }
      }
      break
    }
    case ToolsMenu_Pages.tools_firmware: {
    
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.tools_firmware}`, search}, { state: { global_index: 2, tab: 0 } })
          break
        }
      }
      break
    }
    case ToolsMenu_Pages.tools_companies:
      Navigator({pathname: `/${ToolsMenu_Pages.tools_companies}`, search}, {state: {global_index:3, tab:0}})
      break
    
      case ToolsMenu_Pages.tools_users:
      Navigator({pathname: `/${ToolsMenu_Pages.tools_users}`, search}, {state: {global_index:4, tab:0}})
    break
    
    case ToolsMenu_Pages.tools_graphQL:
      Navigator({pathname: `/${ToolsMenu_Pages.tools_graphQL}`, search}, {state: {global_index:5, tab:0}})
      break
    
      default: console.log("Error page not found (404)???, [ToolsMenu]")
  }
}
